import {
  View,
  Text,
  FlatList,
  TouchableOpacity,
  Platform,
  Animated,
} from "react-native";
import React from "react";
import { LinearGradient } from "expo-linear-gradient";
import { styles } from "../styles/styles";
import SlideItem from "./SlideItem";
import GlobalStyles from "../../../globalStyles/globalStyles";
import Pagination from "./Pagination";
import FeedIcons from "../../../assets/Icons/FeedIcons";
import Carousel from "../../ExeperienceScreens/Experience/components/generalComponents/Carousel";
import CarouselPreview from "../../ExeperienceScreens/Experience/components/generalComponents/CarouselPreview";

export default function ProfileCard({
  currentProfile,
  height,
  index,
  imageHeight,
  // handleOnScroll,
  handleOnViewableItemsChanged,
  handleLikePress,
  viewabilityConfig,
  interest,
  chatProfile,
  fromPreview,
  fromHomeFeed,
}: {
  currentProfile: any;
  height: any;
  index: any;
  imageHeight?: any;
  // handleOnScroll: any;
  handleOnViewableItemsChanged: any;
  handleLikePress?: any;
  viewabilityConfig: any;
  interest?: boolean;
  chatProfile?: boolean;
  fromPreview?: boolean;
  fromHomeFeed?: boolean;
}) {
  const handleOnScroll = (event: any) => {
    Animated.event(
      [
        {
          nativeEvent: {
            contentOffset: {
              x: new Animated.Value(0),
            },
          },
        },
      ],
      {
        useNativeDriver: false,
      }
    )(event);
  };
  return (
    <View style={styles.ProfileCards}>
      {currentProfile && (
        <View style={styles.ProfileCard}>
          <View
            style={[
              styles.ProfileCardImg,
              {
                height: Platform.OS === "web" ? 500 : 560,
                backgroundColor: "black",
                width: "100%",
              },
            ]}
          >
            {Platform.OS === "web" ? (
              <>
                <CarouselPreview data={currentProfile?.photos} />
              </>
            ) : (
              <>
                {currentProfile?.photos?.length > 0 && (
                  <FlatList
                    data={currentProfile?.photos}
                    renderItem={({ item }) => (
                      <SlideItem item={item} imageHeight={imageHeight} />
                    )}
                    horizontal
                    pagingEnabled
                    snapToAlignment="center"
                    showsHorizontalScrollIndicator={false}
                    onScroll={handleOnScroll}
                    onViewableItemsChanged={handleOnViewableItemsChanged}
                    viewabilityConfig={viewabilityConfig}
                  />
                )}
              </>
            )}

            <LinearGradient
              colors={["transparent", "rgba(255,255,255,1)"]}
              style={styles.HomeDisplayCardInfo}
            >
              <View style={styles.HomeDisplayCardInfoInner}>
                <View>
                  <View style={styles.BadgeLabel}>
                    <Text
                      style={[
                        GlobalStyles.heading2,
                        {
                          lineHeight: 33,
                        },
                      ]}
                    >
                      {currentProfile.firstName}
                    </Text>
                    {currentProfile.isVerified && <FeedIcons.VerifiedBadge />}
                  </View>
                  <Text style={GlobalStyles.bodyText}>Active Now</Text>
                </View>
                {/* {!fromPreview && (
                  <TouchableOpacity
                    onPress={() =>
                      handleLikePress("profileLike", currentProfile?.photos[0])
                    }
                    style={styles.LikeIconCircle}
                  >
                    <FeedIcons.LikeIcon />
                  </TouchableOpacity>
                )} */}
                {fromHomeFeed && (
                  <TouchableOpacity
                    onPress={() =>
                      handleLikePress("profileLike", currentProfile?.photos[0])
                    }
                    style={styles.LikeIconCircle}
                  >
                    <FeedIcons.LikeIcon />
                  </TouchableOpacity>
                )}
              </View>
            </LinearGradient>
            {currentProfile?.photos?.length > 1 && (
              <View style={styles.Paginatiom}>
                <Pagination data={currentProfile?.photos} index={index} />
              </View>
            )}
          </View>
        </View>
      )}
    </View>
  );
}
